Vue.component("show-user", {

    mixins: [require("../../mixins/tab-state")],

    props: ["userProfile"],

    data () {
        return {
            user: this.userProfile
        };
    },

    computed: {

        companySettingsUrl () {
            return "/settings";
        },

        companyUsersUrl () {
            return "/settings/#users-tab";
        },

        showPermissions () {
            return this.teamIsActive() && !["Tenant", "Landlord"].includes(this.user.role) || this.userHasRole("Support");
        },

        showNotifications () {
            return this.teamIsActive() && !["Tenant", "Landlord"].includes(this.user.role) || this.userHasRole("Support");
        }

    },

    mounted () {

        this.usePushStateForTabs(".user-tabs");

        $(".stickyside").stick_in_parent({
            offset_top: 90
        });

    }

});
